/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useTranslation } from "react-i18next";

// components imports
import { Card, Col, Row } from "antd";
import { LoginForm } from "@/components/Forms/LoginForm";
import { LanguageSelector } from "@/components/UI/LanguageSelector";

const baseClassName = "login-screen"
/**
 * Login Screen
 * @returns JSX.Element
 */
export const LoginScreen = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Row className={`${baseClassName} w-100`} align={"middle"} justify={"center"}>
      <Col lg={10} xl={9} md={14} xs={24}>
        <Card className={`${baseClassName}__card`} title={t("login.title")} extra={<LanguageSelector />}>
          <LoginForm />
        </Card>
      </Col>
    </Row>
  );
};
